export interface Instrument {
  isin?: string
  instrumentReferences: InstrumentReference[]
  title: string
  mifirCode: MifirCode
  isComposite: boolean
}

export type InstrumentReferenceString = `${string}/${string}`

export const instrumentReferenceToString = (
  instrumentReference: InstrumentReference | { idType: string; idValue: string }
): InstrumentReferenceString => {
  return `${instrumentReference.idType}/${instrumentReference.idValue}`
}
export interface InstrumentReference {
  idType: string
  idValue: string
}

const stringToInstrumentReference = (s: InstrumentReferenceString): InstrumentReference => {
  const parts: string[] = s.split('/')

  return {
    idType: parts[0],
    idValue: parts[1],
  }
}

export const isInstrumentReferenceStringIsin = (s: InstrumentReferenceString): boolean =>
  stringToInstrumentReference(s).idType === 'isin'

// The rest of the system models MifirCodes as plain strings, but they are constrained in practice
// to a finite set of values. The transparency database holds the master list of codes, so this
// enum should remain aligned with the contents of the `mifir_identifier_codes` table.
export enum MifirCode {
  SHRS = 'SHRS',
  ETFS = 'ETFS',
  DPRS = 'DPRS',
  CRFT = 'CRFT',
  OTHE = 'OTHE',
  SDRV = 'SDRV',
  SFPS = 'SFPS',
  BOND = 'BOND',
  ETCS = 'ETCS',
  ETNS = 'ETNS',
  EMAL = 'EMAL',
  DERV = 'DERV',
}
